// Feature flag for "Share your presets, we organize them" (/organize). Off unless REACT_APP_ORGANIZE_ENABLED=1 at
// build time; the backend has its own flag (ORGANIZE_ENABLED) and answers 404 while it is off.
export const ORGANIZE_ENABLED = process.env.REACT_APP_ORGANIZE_ENABLED === '1';
